import { useMemo } from 'react';
import { biLogger } from '../../../services/biLogger';

interface ITrackVideoDeleteFinish {
  videoId: string;
  sessionId: string;
}

export const useTrackVideoDeleteFinish = () =>
  useMemo(
    () => ({
      trackVideoDeleteFinish: ({
        videoId,
        sessionId,
      }: ITrackVideoDeleteFinish) =>
        biLogger.videoMakerVideoDeleteFinished({
          videoId,
          sessionId,
        }),
    }),
    [],
  );
